import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMultiPreassignment extends Layout {
    labelErrorsNumber: Label;
    labelErrorsTitle: Label;
    labelOrdersNumber: Label;
    labelTitle: Label;
    sourceValidatedAvailableMove: DataSource;
    tableMultiPreassignments: Table;
}
